export default __webpack_public_path__ + "static/media/SleepingBanana.06636e36.png";